import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Indonesian NIK validator following Single Responsibility Principle
 */
export class IdValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Indonesian NIK',
      pattern: /^\d{16}$/,
      length: 16
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'Indonesian NIK must be exactly 16 digits'
    );
  }

  validateChecksum(id) {
    // NIK structure validation
    const provinceCode = id.substring(0, 2);
    const regencyCode = id.substring(2, 4);
    const districtCode = id.substring(4, 6);
    const birthDate = id.substring(6, 8);
    const birthMonth = id.substring(8, 10);
    const birthYear = id.substring(10, 12);
    
    // Validate birth date
    const day = parseInt(birthDate);
    const month = parseInt(birthMonth);
    
    // For females, birth date is added by 40
    const actualDay = day > 40 ? day - 40 : day;
    
    if (actualDay < 1 || actualDay > 31) {
      return ValidationResult.invalid('Invalid birth date');
    }
    
    if (month < 1 || month > 12) {
      return ValidationResult.invalid('Invalid birth month');
    }

    return ValidationResult.valid('Valid Indonesian NIK');
  }
}